import React from "react";
import { useEffect, useState } from "react";
import Select from "react-select";
import { getAllData, postUsersData, verifytoken } from "../../../../services/ApiCallingUserServices";
import Switch from "react-switch";
import { alphaNumericspace, generatePDF, formatDate } from "../../../commonClass/CommonValidation";
import { useNavigate } from "react-router-dom";
import { ClearLocalStorage, GetLocalStorage } from "../../../commonClass/Session";
import { useDispatch, useSelector } from "react-redux";
import { loaderActions } from "../../../../_actions/loader.actions";
import { ConfirmationModal } from "../../../../customControl/ConfirmationModal";
import CustomSelection from "../../../../customControl/CustomSelection";
import { ExportExcel } from "../../../commonClass/ExportExcel";
import CustomTable from "../../../../customControl/CustomTable";
import CommonFilter from "../../../../customControl/CommonFilter";
import CustomColumn from "../../../../customControl/CustomColumn";

const AccesspointmasterOtherPoints = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [formValue, setFormValue] = useState({
        AccessPointOtherId: 0,
        LocationId: 0,
        PickUpPoint: "",
        DropPoint: "",
        IsActive: false
    });
    const [formErrors, setFormError] = useState({});
    const [modalShow, setModalShow] = useState(false);
    const [mode, setMode] = useState("Add");
    const [editdisabled, setEditDisabled] = useState(true);
    const [disabled, setDisabled] = useState();
    const [citydisable, setCityDisable] = useState(false);


    const user = useSelector(store => store.userstatus.tba);
    const [useredit, setUserEdit] = useState(true);
    const [useradd, setUserAdd] = useState(true);
    const [userexport, setUserExport] = useState(true);

    const [OtherPointList, setOtherPointList] = useState([]);
    const [filterList, setFilterList] = useState([]);

    const [allCity, setallCity] = useState([]);
    const [citydata, setCityData] = useState([]);
    const [allLocation, setAllLocation] = useState({
        continent: [],
        country: [],
        region: [],
        state: [],
    });

    const [searchvalue, setSearchValue] = useState("");
    const [searchby, setSerachBy] = useState("All");
    const [searchDisabled, setSerachDisabled] = useState(false);

    //#region handle rights
    useEffect(() => {
        if (user?.length > 0) {
            const pathName = window?.location?.pathname?.toLowerCase();
            const hasRights = user?.find(x => x?.PageLink?.toLowerCase() === pathName)
            if (!hasRights?.URightView) {
                navigate("/dashboard");
                return;
            }
            setUserAdd(hasRights?.URightAdd);
            setUserEdit(hasRights?.URightEdit);
            setUserExport(hasRights?.URightExport);
        }
    }, [user])
    //#endregion

    //#region API calling functions
    useEffect(() => {
        async function fetchData() {
            dispatch(loaderActions.start());
            const statusoftoken = await verifytoken();
            if (statusoftoken) {
                Promise.allSettled([
                    getcitylist(),
                    getaccesspointotherlist()
                ])
                dispatch(loaderActions.end());
            }
            else {
                ClearLocalStorage();
                dispatch(loaderActions.end());
                dispatch({ type: "SESSIONOUT", message: "Your Session Expired. Please Login Again!" })
            }
        }
        fetchData();
    }, [])

    const getaccesspointotherlist = async () => {
        const accesspointotherlist = await getAllData("/master/v1/getaccesspointotherlist")
        if (accesspointotherlist?.status) {
            accesspointotherlist?.data?.map((obj) => {
                obj.IsActiveFormat = obj?.IsActive === true ? "Active" : "InActive"
                obj.CreatedOnFormat = formatDate(obj?.CreatedDate)
                return obj;
            })
            setOtherPointList(accesspointotherlist?.data);
            setFilterList(accesspointotherlist?.data)
        }
    }

    const getcitylist = async () => {
        const getallcity = await getAllData("/master/v1/getallcity")
        setallCity(getallcity?.data);
        setCityData(getallcity?.data?.filter(IsAct => IsAct.IsActive === true));
    }

    const getalllocationbyCity = async (locationid) => {
        const locationbyid = await postUsersData("/master/v1/getlocationbyid", { LocationId: locationid });
        const otherLocations = (labelName) => {
            return locationbyid?.data?.map((obj) => ({
                label: obj?.[labelName],
                value: 1
            }))
        }

        if (locationbyid?.status) {
            setAllLocation({
                continent: otherLocations("continentName"),
                country: otherLocations("countryName"),
                region: otherLocations("regionName"),
                state: otherLocations("stateName"),
            });
        }
        else {
            setAllLocation({
                continent: [],
                country: [],
                region: [],
                state: [],
            });
        }
    }
    //#endregion

    //#region set city options
    const cityList = citydata?.map(obj => ({
        label: obj?.City,
        value: obj?.LocationId
    }));
    //#endregion


    //#region handle on change functions
    const handlecity = (e) => {
        formValue.LocationId = e.value
        getalllocationbyCity(e.value);
        setFormError({});
        setEditDisabled(false);
    }

    const handleOnChange = (name, value) => {
        setEditDisabled(false);
        setFormError({});
        setFormValue((prev) => ({ ...prev, [name]: value }));
    }

    const handleisActive = (e) => {
        if (mode === "Add") {
            formValue.IsActive = e
            setEditDisabled(false);
            setFormError({});
        }
        else {
            setModalShow(true);
        }
    }
    const handleConfirmation = (e) => {
        if (e === true) {
            formValue.IsActive = !formValue?.IsActive
            setEditDisabled(false);
            setFormError({});
        }
        setModalShow(false);
    }
    //#endregion

    //#region columns
    const columns = [
        {
            name: "Pick Up Point",
            key: "PickUpPoint",
            sortable: true,
            reorder: true,
            float: "left",
            isSearch: true,
            selector: (data) => data?.PickUpPoint
        },
        {
            name: "Drop Point",
            key: "DropPoint",
            sortable: true,
            reorder: true,
            float: "left",
            isSearch: true,
            selector: (data) => data?.DropPoint
        },
        {
            name: "City",
            key: "City",
            sortable: true,
            reorder: true,
            float: "left",
            isSearch: true,
            selector: (data) => data?.City
        },
        {
            name: "State",
            key: "StateName",
            sortable: true,
            reorder: true,
            float: "left",
            isSearch: true,
            selector: (data) => data?.StateName
        },
        {
            name: "Active",
            key: "IsActiveFormat",
            sortable: true,
            reorder: true,
            float: "left",
            isSearch: true,
            selector: (data) => data?.IsActiveFormat
        },
        {
            name: "Created Date",
            key: "CreatedOnFormat",
            sortable: true,
            reorder: true,
            float: "left",
            isSearch: false,
            selector: (data) => new Date(data?.CreatedDate),
            format: (data) => data?.CreatedOnFormat,
        },
        {
            name: "Edit",
            isSearch: false,
            selector: (data) => <button type="button" className="border-0 p-0 bg-body set_disableclr" disabled={!useredit}><i className="fa fa-edit" onClick={() => handleEditViewMode("Edit", data?.AccessPointOtherId)}></i></button>
        },
        {
            name: "View",
            isSearch: false,
            selector: (data) => <button type="button" className="border-0 p-0 bg-body set_disableclr"><i className="fa fa-eye" onClick={() => handleEditViewMode("View", data?.AccessPointOtherId)}></i></button>
        }
    ];
    //#endregion

    //#region retrieve data on edit and view
    const handleEditViewMode = (type, id) => {
        setDisabled(type === "Edit" ? false : true);
        setMode(type);
        setEditDisabled(true);
        setSerachDisabled(true);
        RetriveData(id);
    }

    const RetriveData = (id) => {
        setFormError({});
        OtherPointList?.map(obj => {
            if (obj.AccessPointOtherId === id) {
                formValue.AccessPointOtherId = obj?.AccessPointOtherId
                formValue.LocationId = obj?.LocationId
                formValue.PickUpPoint = obj?.PickUpPoint
                formValue.DropPoint = obj?.DropPoint
                formValue.IsActive = obj?.IsActive
                // Check In-Active Data and add in Dropdown...
                const allcitylist = allCity?.filter(IsAct => IsAct?.IsActive === true);
                setCityData(allCity?.filter(IsAct => IsAct?.IsActive === true));
                setCityDisable(false);
                if (!allcitylist?.find(IsCity => IsCity?.LocationId === obj?.LocationId)) {
                    setCityDisable(true)
                    setCityData((prvCityData) => prvCityData?.length > 0 ? [...prvCityData, allCity?.find(isCity => isCity?.LocationId === obj?.LocationId)] : [])

                }
                getalllocationbyCity(obj?.LocationId);
            }
        });
    }
    //#endregion


    //#region validations
    const validateData = () => {
        let status = true;
        let error = {};
        if (formValue?.LocationId === 0) {
            error.LocationId = "Kindly select the City name";
            status = false;
        }
        if (!formValue?.PickUpPoint || formValue?.PickUpPoint?.trim()?.length === 0) {
            error.PickUpPoint = "Kindly Enter Pick Up Point";
            status = false;
        }
        if (!formValue?.DropPoint || formValue?.DropPoint?.trim()?.length === 0) {
            error.DropPoint = "Kindly Enter Drop Up Point";
            status = false;
        }

        const isPickUpDuplicate = OtherPointList?.filter((prev) => prev?.AccessPointOtherId !== formValue.AccessPointOtherId && prev?.LocationId === formValue.LocationId && prev?.PickUpPoint?.trim() === formValue.PickUpPoint?.trim());
        const isDropPointDuplicate = OtherPointList?.filter((prev) => prev?.AccessPointOtherId !== formValue.AccessPointOtherId && prev?.LocationId === formValue.LocationId && prev?.DropPoint?.trim() === formValue.DropPoint?.trim());

        if (formValue?.PickUpPoint?.trim()?.length > 0 && isPickUpDuplicate?.length > 0) {
            error.PickUpPoint = "Pick Point already exists";
            status = false;
        }
        if (formValue?.DropPoint?.trim()?.length > 0 && isDropPointDuplicate?.length > 0) {
            error.DropPoint = "Drop Points is already exist";
            status = false;
        }


        setFormError(error);

        if (Object.keys(error)?.length > 0) {
            const id = Object.keys(error)?.[0];
            document.getElementById(id)?.focus();
        }
        return status;
    }
    //#endregion

    //#region Add and Update data
    const handleSubmitData = async () => {
        if (validateData()) {
            const statusoftoken = await verifytoken();
            dispatch(loaderActions.start());
            if (statusoftoken) {
                let user = GetLocalStorage();
                const UpsertAccessPointOther = await postUsersData("/master/v1/UpsertAccessPointOther", { ...formValue, UserId: user?.userMasterID })
                if (UpsertAccessPointOther?.status) {
                    dispatch({ type: "ALERTING", message: UpsertAccessPointOther?.message });
                    getaccesspointotherlist();
                    handleClear();
                    setDisabled(false);
                    setEditDisabled(true);
                    dispatch(loaderActions.end());
                }
                else {
                    dispatch(loaderActions.end());
                    dispatch({ type: "ALERTING", message: UpsertAccessPointOther?.message });
                }
            }
            else {
                ClearLocalStorage();
                dispatch({ type: "SESSIONOUT", message: "Your Session Expired. Please Login Again!" })
            }
        }
    }
    //#endregion

    //#region clear function
    const handleClear = () => {
        setMode("Add");
        setDisabled(false);
        setFormError({});
        setFormValue((prev) => ({
            ...prev,
            AccessPointOtherId: 0,
            LocationId: 0,
            PickUpPoint: "",
            DropPoint: "",
            IsActive: false
        }));
        setAllLocation({
            continent: [],
            country: [],
            region: [],
            state: [],
        });
        getcitylist();
        getaccesspointotherlist();
        setCityDisable(false);
        setCityData([]);
        setEditDisabled(true);
        setSerachDisabled(false);
        setSerachBy("All");
        setSearchValue("");
    }
    //#endregion


    //#region pdf export function
    const PDFExport = () => {
        const keys = columns?.filter((obj) => (obj?.key && !obj.omit))?.map((obj) => obj.key);
        const pdfColumns = columns?.filter((obj) => (obj?.key && !obj.omit))?.map((obj) => obj.name);
        const rows = OtherPointList?.map((obj) => keys?.map((key) => obj[key]))
        generatePDF(pdfColumns, rows, "OtherPoint", "OtherPoint")
    }
    //#endregion

    //#region excel export function
    const ExcelExport = () => {
        const dispalyname = columns?.filter((obj) => (obj?.key && !obj.omit))?.map((obj) => obj.name);
        const fields = columns?.filter((obj) => (obj?.key && !obj.omit))?.map((obj) => obj.key);
        ExportExcel(dispalyname, fields, OtherPointList, "OtherPoint", "OtherPoint.xls");
    }
    //#endregion


    return (
        <>
            <div className="container-fluid form_border py-5 my-3">
                <form action="" >
                    <div className="row mx-1">
                        <div className="col-lg-12 col-md-12 col-sm-12">
                            <div className="row">
                                <CustomColumn labelText="Continent" labelId="ContinentId" classes={"mx-lg-auto"} colNum={2} colMDNum={6} colLabel={12} colMDLabel={12} colChildren={12} colMDChildren={12} isRequired>
                                    <Select
                                        inputId="ContinentId"
                                        className="dropdown select_dropdown"
                                        options={allLocation?.continent}
                                        value={allLocation?.continent?.find(({ value }) => value === 1)}
                                        isDisabled
                                    />
                                </CustomColumn>
                                <CustomColumn labelText="Country" labelId="CountryId" classes={"mx-lg-auto"} colNum={2} colMDNum={6} colLabel={12} colMDLabel={12} colChildren={12} colMDChildren={12} isRequired>
                                    <Select
                                        inputId="CountryId"
                                        className="dropdown select_dropdown"
                                        options={allLocation?.country}
                                        value={allLocation?.country?.find(({ value }) => value === 1)}
                                        isDisabled
                                    />
                                </CustomColumn>
                                <CustomColumn labelText="Region" labelId="RegionId" classes={"mx-lg-auto"} colNum={2} colMDNum={6} colLabel={12} colMDLabel={12} colChildren={12} colMDChildren={12} isRequired>
                                    <Select
                                        inputId="RegionId"
                                        className="dropdown select_dropdown"
                                        options={allLocation?.region}
                                        value={allLocation?.region?.find(({ value }) => value === 1)}
                                        isDisabled
                                    />
                                </CustomColumn>
                                <CustomColumn labelText="State" labelId="StateId" classes={"mx-lg-auto"} colNum={2} colMDNum={6} colLabel={12} colMDLabel={12} colChildren={12} colMDChildren={12} isRequired>
                                    <Select
                                        inputId="StateId"
                                        className="dropdown select_dropdown"
                                        options={allLocation?.state}
                                        value={allLocation?.state?.find(({ value }) => value === 1)}
                                        isDisabled
                                    />
                                </CustomColumn>
                                <CustomColumn labelText="City" labelId="LocationId" classes={"mx-lg-auto"} colNum={2} colMDNum={6} colLabel={12} colMDLabel={12} colChildren={12} colMDChildren={12} isRequired>
                                    <CustomSelection
                                        datalist={cityList}
                                        inputId="LocationId"
                                        fieldid={formValue?.LocationId}
                                        SelectionChange={handlecity}
                                        isdisable={disabled}
                                        isactivedisable={citydisable}
                                        issearchable={true}
                                    />
                                    {formErrors.LocationId && <p className="text-danger text-start">{formErrors.LocationId}</p>}
                                </CustomColumn>
                            </div>
                        </div>
                    </div>

                    <div className="mb-1 mt-4 col-lg-11 mx-lg-5">
                        <div className="row">
                            <CustomColumn labelText="Pick Up Points" labelId="PickUpPoint" isRequired>
                                <input className="form-control"
                                    type="text"
                                    id="PickUpPoint"
                                    name="PickUpPoint"
                                    value={formValue.PickUpPoint}
                                    onChange={(e) =>
                                        e.target.value?.length <= 150 &&
                                        handleOnChange(e.target.name, alphaNumericspace(e.target.value))
                                    }
                                    disabled={disabled ? true : false}
                                    placeholder="Pick Up Points"
                                    maxLength={150}
                                />
                                {formErrors.PickUpPoint && <p className="text-danger text-start">{formErrors.PickUpPoint}</p>}
                            </CustomColumn>

                            <CustomColumn labelText="Drop Points" labelId="DropPoint" isRequired>
                                <input className="form-control"
                                    type="text"
                                    id="DropPoint"
                                    name="DropPoint"
                                    value={formValue.DropPoint}
                                    onChange={(e) =>
                                        e.target.value?.length <= 150 &&
                                        handleOnChange(e.target.name, alphaNumericspace(e.target.value))
                                    }
                                    disabled={disabled ? true : false}
                                    placeholder="Drop Points"
                                    maxLength={150}
                                />
                                {formErrors.DropPoint && <p className="text-danger text-start">{formErrors.DropPoint}</p>}
                            </CustomColumn>

                            <CustomColumn colNum={6} labelText="Active" labelId="Active" classChildren={"align-content-center"}>
                                <Switch
                                    onChange={handleisActive}
                                    checked={formValue?.IsActive}
                                    className="react-switch"
                                    disabled={disabled ? true : false}
                                />
                                <ConfirmationModal
                                    show={modalShow}
                                    onHide={() => setModalShow(false)}
                                    noconfirm={() => handleConfirmation(false)}
                                    yesconfirm={() => handleConfirmation(true)}
                                />
                            </CustomColumn>
                        </div>
                    </div>

                    <div className="mt-3 d-flex justify-content-center">
                        <button type="button" className="btn btn-primary mx-1" onClick={() => handleSubmitData()} disabled={disabled || editdisabled || (mode === "Add" && !useradd)}>{mode === "Edit" ? "Update" : "Add"}</button>
                        <button type="button" className="btn btn-primary mx-1" onClick={() => handleClear()}>Clear</button>
                    </div>

                    <CommonFilter
                        columns={columns?.filter((prev) => prev?.isSearch)}
                        filterList={filterList}
                        searchDisabled={searchDisabled}
                        getdata={getaccesspointotherlist}
                        setlistdata={setOtherPointList}
                        searchvalue={searchvalue}
                        setSearchValue={setSearchValue}
                        searchby={searchby}
                        setSerachBy={setSerachBy}
                    />

                    <CustomTable
                        columns={columns}
                        data={OtherPointList}
                        PdfExport={PDFExport}
                        ExportToExcel={ExcelExport}
                        disabled={!userexport}
                    />
                </form>
            </div>
        </>
    )
}

export default AccesspointmasterOtherPoints